// In your gatsby-browser.js
import 'lazysizes';
